import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { Col, ColProps } from 'react-bootstrap';

type Props = {
  title: string;
  children: ReactNode;
  changed?: boolean;
  highlight?: boolean;
} & ColProps;

const DisplayDataItem: React.FC<Props> = ({
  title,
  children,
  changed = false,
  highlight = false,
  ...props
}) => {
  const classesItem = classnames({
    changed,
    highlight
  });

  return (
    <Col {...props} className={classesItem}>
      <b className="dd-title" data-testid={`ddi_title_${title}`}>
        {title}
      </b>
      <div className="dd-content" data-testid="ddi-content">
        {children}
      </div>
    </Col>
  );
};

export default DisplayDataItem;
